import React from 'react';
import Button from '../../../Presentation/components/ui/Button';
import BrandList from './BrandList';
import TypeList from './TypeList';
import TagList from './TagList';

type ClassificationsSubTab = 'brands' | 'types' | 'tags';

const SUB_TABS: {key: ClassificationsSubTab; label: string}[] = [
  {key: 'brands', label: 'البراندات'},
  {key: 'types', label: 'الأنواع'},
  {key: 'tags', label: 'الوسوم'}
];

interface ClassificationsTabContentProps {
  activeSubTab: ClassificationsSubTab;
  onSubTabChange: (tab: ClassificationsSubTab) => void;
}

export const ClassificationsTabContent: React.FC<ClassificationsTabContentProps> = ({
  activeSubTab,
  onSubTabChange
}) => (
  <div className="space-y-6">
    <div className="flex border-b border-gray-200 bg-gray-50 rounded-t-xl">
      {SUB_TABS.map((tab) => (
        <Button
          key={tab.key}
          variant={activeSubTab === tab.key ? 'primary' : 'ghost'}
          className={`rounded-none border-b-2 ${
            activeSubTab === tab.key ? 'border-primary' : 'border-transparent'
          } text-lg font-bold px-8 py-4`}
          onClick={() => onSubTabChange(tab.key)}
        >
          {tab.label}
        </Button>
      ))}
    </div>

    <div className="p-6">
      {activeSubTab === 'brands' && <BrandList />}
      {activeSubTab === 'types' && <TypeList />}
      {activeSubTab === 'tags' && <TagList />}
    </div>
  </div>
);
